import { DEFAULT_TIMEZONE } from "../../../../utils/dateTime/constants";
import {
    getUserTimeZone,
    unixToZonedBylineDate,
} from "../../../../utils/dateTime/library";
import { isBrowser } from "../../../../utils/environmentDetection/library";

/**
 * Corrections component that displays a list of corrections.
 *
 * @param {Object} props - The component props.
 * @param {Array} props.data - An array of correction objects.
 * @param {String} props.data[].correction - The correction text.
 * @param {Number} props.data[].epochDate - The date of the correction, represented as unix timestamp.
 * @returns {JSX.Element|null} The rendered component or null if no data is provided.
 */
const Corrections = ({ data }) => {
    if (!Array.isArray(data) || data.length === 0) {
        return null;
    }

    const timezone = isBrowser() ? getUserTimeZone() : DEFAULT_TIMEZONE;

    const correctionsJSX = data
        .filter(({ correction, epochDate }) => correction && epochDate) // Filter out corrections without correction text or date
        .map(({ correction, epochDate }) => (
            <li className="correction-item" key={`${correction}-${epochDate}`}>
                <div className="correction-text">{correction}</div>
                <div
                    className="correction-date"
                    suppressHydrationWarning={true}
                >
                    {unixToZonedBylineDate(epochDate, timezone)}
                </div>
            </li>
        ));

    return correctionsJSX.length > 0 ? (
        <div className="corrections" data-testid="corrections">
            <h3>Corrections</h3>
            <ul className="corrections-list">{correctionsJSX}</ul>
        </div>
    ) : null;
};

export default Corrections;
